
import { Component, Prop, Watch } from 'vue-property-decorator'
import Mixin from './../helpers/mixin'

@Component({})
export default class Blocks extends Mixin {
  @Prop({ default: 4 }) itemsPerRow: number

  @Prop({ default: false }) hasButton: boolean

  @Prop() amountOfItems: number

  dropdownOpen = true

  get showDropdown(): boolean {
    return this.hasButton && (this.amountOfItems / this.itemsPerRow > 1) && (this.isPhone || this.isTabletP)
  }

  toggle(): void {
    if (!this.showDropdown) return
    this.dropdownOpen = !this.dropdownOpen
  }

  @Watch('showDropdown')
  onShowDropdownChanged(showDropdown: boolean): void {
    // reset dropdownOpen back to true
    if (!showDropdown && !this.dropdownOpen) this.dropdownOpen = true
  }
}
